"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createConsoleLogMessages = void 0;
const tslib_1 = require("tslib");
const client_common_1 = require("@neo-one/client-common");
const node_vm_1 = require("@neo-one/node-vm");
const utils_1 = require("@neo-one/utils");
const lodash_1 = tslib_1.__importDefault(require("lodash"));
const processTrace_1 = require("./processTrace");
const inspect = (value, wrapString = false) => {
    if (value === null) {
        return wrapString ? JSON.stringify(value) : value;
    }
    if (Array.isArray(value)) {
        return wrapString ? JSON.stringify(value) : value;
    }
    if (value instanceof Map) {
        return `Map { ${[...value.entries()]
            .map(([key, val]) => `${inspect(key, true)} => ${inspect(val, true)}`)
            .join(', ')} }`;
    }
    if (value instanceof Set) {
        return `Set { ${[...value].map((val) => inspect(val, true)).join(', ')} }`;
    }
    if (typeof value === 'string') {
        return wrapString ? `'${value}'` : value;
    }
    if (typeof value === 'function') {
        return '[Function]';
    }
    if (typeof value === 'object') {
        const result = lodash_1.default.fromPairs(Object.entries(value).map(([key, val]) => [key, inspect(val)]));
        return wrapString ? JSON.stringify(result) : result;
    }
    return wrapString ? JSON.stringify(value) : value;
};
const extractValueFromStackItem = (stackItem) => {
    const type = stackItem.asArray()[0].asBigIntegerUnsafe().toNumber();
    switch (type) {
        case 1:
            return undefined;
        case 2:
            return null;
        case 3:
            return stackItem.asArray()[1].asBoolean();
        case 4:
            return stackItem.asArray()[1].asString();
        case 5:
            return `Symbol(${stackItem.asArray()[1].asString()})`;
        case 6:
            return stackItem.asArray()[1].asBigIntegerUnsafe().toString(10);
        case 7:
            return lodash_1.default.fromPairs(utils_1.utils.zip(stackItem.asArray()[1].asArray()[0].asArray().map(extractValueFromStackItem), stackItem.asArray()[1].asArray()[1].asArray().map(extractValueFromStackItem)));
        case 8:
            return stackItem.asArray()[1].asArray().map(extractValueFromStackItem);
        case 9:
            return stackItem.asArray()[1].asBuffer().toString('hex');
        case 10:
            return new Map(stackItem
                .asArray()[1]
                .asArray()
                .map((value) => value.asArray().map(extractValueFromStackItem)));
        case 11:
            return new Set(stackItem.asArray()[1].asArray().map(extractValueFromStackItem));
        default:
            return `<unknown type ${type}>`;
    }
};
const extractMessageFromStackItem = (stackItem) => {
    const value = extractValueFromStackItem(stackItem);
    return typeof value === 'string' ? value : JSON.stringify(inspect(value));
};
const extractMessage = (value) => {
    const stackItems = node_vm_1.deserializeStackItem(value).asArray()[1].asArray();
    const messages = stackItems.map(extractMessageFromStackItem);
    return messages.join('');
};
const extractLog = (action) => {
    if (action.type === 'Log') {
        return undefined;
    }
    const args = action.args;
    try {
        const event = client_common_1.smartContractConverters.toString(args[0]);
        if (event !== 'console.log') {
            return undefined;
        }
        const line = client_common_1.smartContractConverters.toInteger(args[1], { type: 'Integer', decimals: 0 }).toNumber();
        const message = extractMessage(Buffer.from(client_common_1.smartContractConverters.toBuffer(args[2]), 'hex'));
        return { address: action.address, line, message };
    }
    catch (_a) {
        return undefined;
    }
};
const extractConsoleLogs = (actions) => {
    const mutableLogs = [];
    for (const action of actions) {
        const log = extractLog(action);
        if (log !== undefined) {
            mutableLogs.push(log);
        }
    }
    return mutableLogs;
};
exports.createConsoleLogMessages = async (actions, sourceMaps = {}, { bare = false, onlyFileName = false } = { bare: false, onlyFileName: false }) => {
    const logs = extractConsoleLogs(actions);
    if (bare) {
        return logs.map(({ message }) => message);
    }
    const traces = await processTrace_1.processTrace({ trace: logs, sourceMaps, onlyFileName });
    const zipped = utils_1.utils.zip(logs, traces);
    return zipped.map(([{ message }, trace]) => {
        if (trace === undefined) {
            return message;
        }
        const { token, file, line, column } = trace;
        return `${message}\n  at ${token} (${file}:${line}${column === undefined ? '' : `:${column}`})`;
    });
};

//# sourceMappingURL=createConsoleLogMessages.js.map
